import { render } from "./WelcomeScreen.vue?vue&type=template&id=51198a33"
import script from "./WelcomeScreen.vue?vue&type=script&lang=js"
export * from "./WelcomeScreen.vue?vue&type=script&lang=js"
script.render = render

export default script